module.exports = __webpack_public_path__ + "img/document.51b2e37e.png";